import { supabase } from "@/integrations/supabase/client";

export const useMentionNotifications = () => {
  const extractMentions = (text: string): string[] => {
    const mentionRegex = /@([\w-]+)/g;
    const mentions: string[] = [];
    let match;
    
    while ((match = mentionRegex.exec(text)) !== null) {
      mentions.push(match[1]);
    }
    
    return [...new Set(mentions)]; // Remove duplicates
  };

  const notifyMentionedUsers = async (
    text: string,
    currentUserId: string,
    currentUsername: string,
    promptId: string
  ) => {
    const mentions = extractMentions(text);
    
    if (mentions.length === 0) return;

    try {
      // Get user IDs for mentioned usernames using public_profiles view for security
      const { data: profiles, error: profileError } = await supabase
        .from('public_profiles')
        .select('id, username')
        .in('username', mentions);

      if (profileError) throw profileError;

      if (!profiles || profiles.length === 0) return;

      // Create notifications for each mentioned user (except the current user)
      const notifications = profiles
        .filter(profile => profile.id !== currentUserId)
        .map(profile => ({
          user_id: profile.id,
          content: `@${currentUsername} mentioned you in a comment`,
          type: 'mention',
          related_id: promptId,
          is_read: false
        }));

      if (notifications.length > 0) {
        const { error: notificationError } = await supabase
          .from('notifications')
          .insert(notifications);

        if (notificationError) throw notificationError;
      }
    } catch (error) {
      console.error('Error creating mention notifications:', error);
    }
  };

  return {
    extractMentions,
    notifyMentionedUsers
  };
};
